<template>
  <div style="height: 300px; position: relative;">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { Bar } from 'vue-chartjs'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export default {
  name: 'BudgetChart',
  components: {
    Bar
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        indexAxis: 'y', // Barre orizzontali
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: false,
            text: 'Budget per Anno'
          }
        },
        scales: {
            x: {
                stacked: true // Stacked
            },
            y: {
                stacked: true, // Stacked
                beginAtZero: true
            }
        }
      }
    }
  }
}
</script>
